package com.wintermar.inspection.core.ui.component.badge.variant

enum class BadgeType {
    GRAY,
    BLUE,
    YELLOW,
    GREEN,
    RED,
    GRAY_GREEN
}

enum class BadgeSizeType {
    SMALL,
    MEDIUM,
    LARGE
}
